import React, { useMemo } from 'react';
import { Body } from './Body';

export const WithStorage = ({ session }) => {
  const { hspId, barcodeValue, ptNo, barcodeType, barcodeDefaultType, hspLogoImageUrl } = useMemo(
    () => JSON.parse(session),
    [session],
  );
  return (
    <Body
      hspId={hspId}
      barcodeValue={barcodeValue}
      ptNo={ptNo}
      barcodeType={barcodeType}
      barcodeDefaultType={barcodeDefaultType}
      hspLogoImageUrl={hspLogoImageUrl}
    />
  );
};
